import { FragmentDeliveryStatus } from './external-export/FragmentDeliveryStatus';

/**
 * External export tab content for a fragment.
 */
export function FragmentExternalExportView() {
  return <FragmentDeliveryStatus />;
}
